import { FairwayTabs } from "./tabs/FairwayTabs";

export const FairwayPage = (): JSX.Element => {
  return <FairwayTabs />;
};
